let previousUrl: string | undefined;

export const getPreviousUrl = () => previousUrl;
export const setPreviousUrl = (url: string) => {
  previousUrl = url;
};
